import { ObjectMapper } from "json-object-mapper";
import { InsightModel } from "./insight.model";

export interface CounterType {
  title: string,
  filterBy: string,
  count: any,
  chartName: string
}

export interface TotalizerCompanyType {
  companyKey: string;
  totalizers: TotalizerType[];
}

export interface TotalizerType {
  key: string,
  total: number,
  percent: string,
  filterBy: string,
  icon: string,
  color: string,
  externalIcon?: string
}

export class InsightHeadcountModel extends InsightModel {
  static create(input: any): InsightHeadcountModel {
    return ObjectMapper.deserialize<InsightHeadcountModel>(InsightHeadcountModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}

export class InsightHeadcountFilterModel {
  companyCNPJ: string;
  costCenterCode: string;
  sex: string;
}
